export default "/fonts/vendor/katex/dist/KaTeX_Size1-Regular.woff?0108e89c9003e8c14ea3c4e99b09653e";